export function UserProfileCircleIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="22"
        cy="22"
        r="21.5"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.6273 32.75H13.3727C12.6398 32.7487 12.0459 32.1548 12.0446 31.4218V30.3446C12.0538 27.2789 14.5375 24.7965 17.603 24.7885H26.393C29.4585 24.7965 31.9422 27.2789 31.9514 30.3446V31.4218C31.9501 32.1548 31.3562 32.7487 30.6273 32.75Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22 19.6113C19.0343 19.6113 16.6291 17.2093 16.6252 14.2436C16.6213 11.2779 19.0201 8.86962 21.9857 8.86171C24.9514 8.8538 27.3629 11.2493 27.3748 14.215C27.3792 15.6438 26.8151 17.0157 25.8068 18.028C24.7985 19.0404 23.4288 19.61 22 19.6113Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
